if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}

// Footer Akkordeon für mobile Ansicht
document.addEventListener('DOMContentLoaded', function() {
  // Funktion zum Initialisieren des Akkordeons
  function initFooterAccordion() {
    const footerBlocks = document.querySelectorAll('.footer__block-list-headline .footer-block__heading');

    footerBlocks.forEach(block => {
      block.removeEventListener('click', toggleAccordion);
      block.removeEventListener('keydown', handleKeydown);

      block.addEventListener('click', toggleAccordion);
      block.addEventListener('keydown', handleKeydown);
    });
  }

  function handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleAccordion.call(this);
    }
  }
  
  // Toggle-Funktion für das Akkordeon
  function toggleAccordion() {
    // Elternelement (Block) finden
    const parentBlock = this.closest('.footer__block-list');
    
    // Prüfen, ob der Block bereits geöffnet ist
    if (parentBlock.classList.contains('is-open')) {
      // Block schließen
      parentBlock.classList.remove('is-open');
      this.setAttribute('aria-expanded', 'false');
    } else {
      // Optional: Alle anderen Blöcke schließen
      document.querySelectorAll('.footer__block-list.is-open').forEach(openBlock => {
        if (openBlock !== parentBlock) {
          openBlock.classList.remove('is-open');
          openBlock.querySelector('.footer-block__heading').setAttribute('aria-expanded', 'false');
        }
      });
      
      // Aktuellen Block öffnen
      parentBlock.classList.add('is-open');
      this.setAttribute('aria-expanded', 'true');
    }
  }
  
  // Akkordeon initialisieren
  initFooterAccordion();
  
  // Bei Größenänderung des Fensters neu initialisieren
  window.addEventListener('resize', function() {
    initFooterAccordion();
  });
});